import { render } from "./SetEditor.vue?vue&type=template&id=48fb81a5&scoped=true"
import script from "./SetEditor.vue?vue&type=script&lang=js"
export * from "./SetEditor.vue?vue&type=script&lang=js"

import "./SetEditor.vue?vue&type=style&index=0&id=48fb81a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fb81a5"]])

export default __exports__